import { useCallback } from 'react';
import { useClipboard } from 'use-clipboard-copy';
import { showSnackbar } from '@client/listeners/lib/snackbar';
import type { UseClipboardOptions } from 'use-clipboard-copy';

/**
 * Creates a useCallback instance that allows for easily creating a copy button for the given link
 * @param  {string} href
 * @return {Function}
 */
export const useImperativeClipboard = (href: string, onSuccess?: UseClipboardOptions['onSuccess']) => {
  const clipboard = useClipboard({
    onSuccess: (onSuccess || (() => showSnackbar(`${href} was successfully copied to your clipboard`))),
    onError: () => showSnackbar(`There was a problem copying ${href} to your clipboard`, 'error'),
  });

  return useCallback(() => {
    clipboard.copy(href);
  }, [clipboard, href]);
};
